import classNames from 'classnames';

import { Body } from '@growtherapy/sprout-ui';

import { GetIntention__CheckIn, IntentionCheckInOutcome } from './types';

const getBgColorForOutcome = (outcome: IntentionCheckInOutcome): string => {
  switch (outcome) {
    case IntentionCheckInOutcome.WORST:
      return 'bg-accent-lasso-surface';
    case IntentionCheckInOutcome.BAD:
      return 'bg-surface-inverse';
    case IntentionCheckInOutcome.NEUTRAL:
      return 'bg-accent-winnie-surface';
    case IntentionCheckInOutcome.GOOD:
      return 'bg-accent-jackie-surface';
    case IntentionCheckInOutcome.BEST:
      return 'bg-accent-sproutie-surface';
  }
};

const ORDERED_OUTCOMES = [
  IntentionCheckInOutcome.WORST,
  IntentionCheckInOutcome.BAD,
  IntentionCheckInOutcome.NEUTRAL,
  IntentionCheckInOutcome.GOOD,
  IntentionCheckInOutcome.BEST,
];

type CheckInData = {
  count: number;
  label: string;
};

export function IntentionCheckInsContent({ checkIns }: { checkIns: GetIntention__CheckIn[] }): JSX.Element {
  const numCheckInsByOutcome = checkIns.reduce(
    (acc, checkIn) => {
      const outcome = checkIn.outcome?.outcome;
      if (outcome) {
        acc[outcome] = { count: (acc[outcome]?.count || 0) + 1, label: checkIn.outcome?.label ?? '' };
      }
      return acc;
    },
    {} as Record<IntentionCheckInOutcome, CheckInData>,
  );

  return (
    <span className='w-full flex flex-row'>
      {ORDERED_OUTCOMES.map((outcome) => {
        const data = numCheckInsByOutcome[outcome];
        if (!data) return null;
        const percentage = (data.count * 100) / checkIns.length;
        const bgColor = getBgColorForOutcome(outcome);
        return (
          <div key={outcome} className='flex flex-col gap-175' style={{ width: `${percentage}%` }}>
            <span className={classNames('h-1.5 flex', bgColor)}></span>
            <Body.Xsmall>{`${data.label} ( ${data.count} )`}</Body.Xsmall>
          </div>
        );
      })}
    </span>
  );
}
